import {
  functions,
  caseRef,
  caseCommentsRef,
  companiesRef,
  goodsRef,
  masterRef,
  newTagsRef,
  noticeRef,
} from "../firebase/index"

import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import SITEINFO from '../constants/siteInfo'
import { envLogDefault } from "../lib/log"
import { actions as adminActions } from './useAdminReducer'
import { VIDEO_THUMBNAIL_STATUS, hasVideoUrl } from '../utils/videoThumbnail'
import {
  collectValidCasePage,
  filterValidCaseRecords,
  isValidCaseRecord,
  warnInvalidCaseRecordOnce,
} from './shareCaseRecord'
// 時間の設定
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')

export const initialState = {
  shareCase: {
    feedbackCaseTag: {},
    industryTagList: [],
    prefTagList: [],
    memberNumTagList: [],
    otherTagList: [],
    newTags: null, // {}

    vimeoStates: [],
    vimeoShow: false,
    cases: [
      // {
      //   user: {},
      //   video: {},
      //   text: '',
      //   vimeoUrls: [],
      //   thumbnailUrls: [],
      //   industryTags: [],
      //   prefTags: [],
      //   otherTags: [],
      //   memberNumTags: [],
      //   newTags: [],
      //   createAt: '',
      // }
    ],
    filterdCases: [],
    case: {},
    caseComments: [
      // {
      //   key: '',
      //   caseKey: '',
      //   user: {},
      //   text: '',
      //   createAt: '',
      // }
    ],
    commentsParCase: [],
    caseGoods: [
      // {
      //   "caseKey": '',
      //   "user": {},
      //   "type": 'case'
      //   "createdAt": ''
      // }
    ],
    caseAllGoods: [],
    goodCaseKeys: [],
    input: {
      user: {},
      video: {
        vimeoUrls: [],
        thumbnailUrls: [],
      },
      text: '',
      industryTags: [],
      prefTags: [],
      memberNumTags: [],
      otherTags: [],
      newTags: [],
      createAt: '',
    },
    inputComments: {
      // [caseKey]: text: '',
    },
    inputCommentVideos: {
      // [caseKey]: {
      //   video: {
      //    thumbnailUrls: [],
      //    vimeoUrls: [],
      //   }
      // },
    },
    // [caseKey]: {
    //   user: { },
    //   caseKey: '',
    //   text: '',
    //   createAt: '',
    //   video: {
    //    thumbnailUrls: [],
    //    vimeoUrls: [],
    //   }
    // },
    editComments: {
      // [caseKey]: {
      //   user: { },
      //   caseKey: '',
      //   text: '',
      //   createAt: '',
      // },
    },
    movie: { url: '' },
    vimeoUrls: [],
    thumbnailUrls: [],
    isChecked: false,
    isShowCmntField: {
      // [caseKey]: true
    },
    isShowCmnts: {
      // [caseKey]: true
    },
    isShowCmntAlls: {
      // [caseKey]: true
    },
    isShowMore: {
      // key: false
    },
    // 会社投稿一覧
    company: {},
  }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'RESET':
      return {
        ...initialState.shareCase
      }
    case 'CASE_RESET':
      envLogDefault("*** CASE_RESET state", state);
      if (process.env.NODE_ENV === 'development') console.log('CASE_RESET');
      return {
        ...initialState.shareCase,
        // NOTE: マスターは消さない
        industryTagList: state.industryTagList,
        prefTagList: state.prefTagList,
        memberNumTagList: state.memberNumTagList,
        otherTagList: state.otherTagList,
      }
    case 'COMMENT_RESET':
      return {
        ...state,
        inputComments: {
          ...state.inputComments,
          [action.field]: ''
        },
        inputCommentVideos: {
          ...state.inputCommentVideos,
          [action.field]: null
        },
      }
    case 'SHARE_CASE_POST_RESET':
      return {
        ...state,
        input: initialState.shareCase.input,
        movie: initialState.shareCase.movie,
        isChecked: initialState.shareCase.isChecked,
        vimeoUrls: initialState.shareCase.vimeoUrls,
        thumbnailUrls: initialState.shareCase.vimeoUrls,
      }
    case 'SET_VIMEO_SHOW':
      return {
        ...state,
        vimeoShow: action.data,
      }
    case 'SET_VIMEO_STATES':
      const exist = state.vimeoStates.find(st => st.videoId === action.field)
      if (!exist) {
        const vs = state.vimeoStates.slice()
        vs.push({videoId: action.field, mounted: action.data})
        return {
          ...state,
          vimeoStates: vs,
        }
      }
      return {
        ...state,
        vimeoStates: state.vimeoStates.map(st => {
          // video id
          if (action.field !== st.videoId) return st
          return {
            ...st,
            mounted: action.data,
          }
        }),
      }
    case 'SET_FEEDBACK_CASE_TAG':
      return {
        ...state,
        feedbackCaseTag: action.data,
      }
    case 'SET_INDUSTRIES':
      return {
        ...state,
        industryTagList: action.data,
      }
    case 'SET_MEMBERNUMS':
      return {
        ...state,
        memberNumTagList: action.data,
      }
    case 'SET_PREFS':
      return {
        ...state,
        prefTagList: action.data,
      }
    case 'CHANGE_OTHER_TAGS':
      return {
        ...state,
        otherTagList: action.data,
      }
    case 'CHANGE_NEW_TAGS':
      return {
        ...state,
        newTags: action.data,
      }

    case 'SET_CASE':
      return {
        ...state,
        case: action.data,
      }
    case 'SET_CASES':
      return {
        ...state,
        cases: action.data,
      }
    case 'SET_FILERED_CASES':
      return {
        ...state,
        filterdCases: action.data,
      }
    case 'SET_COMMENTS':
      return {
        ...state,
        caseComments: action.data,
      }
    case 'SET_COMMENTS_PAR_CASE':
      return {
        ...state,
        commentsParCase: action.data,
      }
    case 'SET_ALL_GOODS':
      return {
        ...state,
        caseAllGoods: action.data,
      }
    case 'SET_GOODS':
      const goodCaseKeys = action.data.map(good => good.caseKey)
      return {
        ...state,
        caseGoods: action.data,
        goodCaseKeys: goodCaseKeys,
      }
    case 'CHANGE_GOOD_CASE_KEYS':
      return {
        ...state,
        goodCaseKeys: action.data,
      }
    case 'SET_EDIT_CASE':
      return {
        ...state,
        input: action.data,
      }
    case 'CHANGE_VALUE':
      return {
        ...state,
        input: {
          ...state.input,
          [action.field]: action.data,
        }
      }
    case 'CHANGE_COMMENT_VALUE':
      // const disabled = action.data === '' ? true : false
      return {
        ...state,
        inputComments: {
          ...state.inputComments,
          [action.field]: action.data
        },
      }
    case 'CHANGE_EDIT_COMMENT_VALUE':
      return {
        ...state,
        editComments: {
          ...state.editComments,
          [action.field]: {
            ...state.editComments[action.field],
            text: action.data
          }
        },
      }
    case 'IS_SHOW_CMNT_FIELD':
      const bool = action.data
      const setComment = bool ? state.caseComments.filter(cmnt => cmnt.key === action.field)[0] : {}
      return {
        ...state,
        isShowCmntField: {
          ...state.isShowCmntField,
          [action.field]: bool
        },
        editComments: {
          [action.field]: setComment
        }
      }
    case 'IS_SHOW_CMNT':
      return {
        ...state,
        isShowCmnts: {
          ...state.isShowCmnts,
          [action.field]: action.data
        }
      }
    case 'IS_SHOW_CMNT_ALL':
      return {
        ...state,
        isShowCmntAlls: {
          ...state.isShowCmntAlls,
          [action.field]: action.data
        }
      }
    case 'SET_MOVIE':
      return {
        ...state,
        movie: {
          ...state.movie,
          [action.field]: action.data,
        }
      }
    case 'SET_VIMEO_URL': {
      const currentVideo = state.input.video || {}
      return {
        ...state,
        input: {
          ...state.input,
          video: {
            ...currentVideo,
            vimeoUrls: [action.data],
            thumbnailUrls: [],
            thumbnailStatus: VIDEO_THUMBNAIL_STATUS.pending,
            thumbnailSourceUri: action.data,
            thumbnailRetryCount: 0,
          }
        }
      }
    }
    case 'SET_THUMBNAIL_URL': {
      const currentVideo = state.input.video || {}
      return {
        ...state,
        input: {
          ...state.input,
          video: {
            ...currentVideo,
            thumbnailUrls: [action.data],
            thumbnailStatus: VIDEO_THUMBNAIL_STATUS.ready,
            thumbnailRetryCount: currentVideo.thumbnailRetryCount || 0,
          }
        }
      }
    }
    case 'SET_CASE_COMMENT_VIMEO_URL': {
      const video_data = state.inputCommentVideos[action.field]
      const caseCmntVideo = (!video_data || !video_data.video) ? {} : video_data.video
      return {
        ...state,
        inputCommentVideos: {
          ...state.inputCommentVideos,
          [action.field]: {
            video: {
              ...caseCmntVideo,
              vimeoUrls: [action.data],
              thumbnailUrls: [],
              thumbnailStatus: VIDEO_THUMBNAIL_STATUS.pending,
              thumbnailSourceUri: action.data,
              thumbnailRetryCount: 0,
            }
          }
        }
      }
    }
    case 'SET_CASE_COMMENT_THUMBNAIL_URL': {
      const thumb_data = state.inputCommentVideos[action.field]
      const caseCmntThumbVideo = (!thumb_data || !thumb_data.video) ? {} : thumb_data.video
      return {
        ...state,
        inputCommentVideos: {
          ...state.inputCommentVideos,
          [action.field]: {
            video: {
              ...caseCmntThumbVideo,
              thumbnailUrls: [action.data],
              thumbnailStatus: VIDEO_THUMBNAIL_STATUS.ready,
              thumbnailRetryCount: caseCmntThumbVideo.thumbnailRetryCount || 0,
            }
          }
        }
      }
    }
    case 'CLEAR_CASE_COMMENT_VIDEO': {
      return {
        ...state,
        inputCommentVideos: {
          ...state.inputCommentVideos,
          [action.field]: {
            video: {}
          }
        }
      }
    }
    case 'RESET_CASE_COMMENT_VIDEO': {
      const data = state.inputCommentVideos[action.field] || {}
      const video = data.video || {}
      const prevThumbs = Array.isArray(video.thumbnailUrls) ? video.thumbnailUrls : []
      const prevVimeo = Array.isArray(video.vimeoUrls) ? video.vimeoUrls : []
      const nextThumbs = prevThumbs.filter((uri, i) => i !== action.num)
      const nextVimeo = prevVimeo.filter((uri, i) => i !== action.num)
      if (nextThumbs.length === 0 && nextVimeo.length === 0) {
        return {
          ...state,
          inputCommentVideos: {
            ...state.inputCommentVideos,
            [action.field]: { video: {} }
          }
        }
      }
      return {
        ...state,
        inputCommentVideos: {
          ...state.inputCommentVideos,
          [action.field]: {
            video: {
              ...video,
              thumbnailUrls: nextThumbs,
              vimeoUrls: nextVimeo,
            }
          }
        }
      }
    }
    case 'CLEAR_VIMEO_VIDEO':
      return {
        ...state,
        input: {
          ...state.input,
          video: {}
        }
      }
    case 'RESET_VIDEO': {
      return {
        ...state,
        input: {
          ...state.input,
          video: {}
        }
      }
    }
    case 'IS_CHECKED':
      return {
        ...state,
        isChecked: action.data
      }
    case 'CHANGE_SHOW_MARE':
      return {
        ...state,
        isShowMore: {
          ...state.isShowMore,
          [action.key]: action.data
        }
      }
    // 会社事例一覧
    case 'SET_COMPANY':
      return {
        ...state,
        company: action.data
      }
    // 新規タグ削除後の state 更新
    case 'DELETE_NEW_TAG_REQUESTS': {
      const remaining = { ...state.newTags }
      // 配列から該当要素を削除
      action.data.forEach(({ requestId, index }) => {
        if (!remaining[requestId]) return
        const tags = remaining[requestId].tag.filter((_, i) => i !== index)
        if (tags.length > 0) {
          remaining[requestId] = { ...remaining[requestId], tag: tags }
        } else {
          // タグがなくなったらリクエスト自体を削除
          delete remaining[requestId]
        }
      })
      return {
        ...state,
        newTags: remaining,
      }
    }
    default: return state
  }
}

const snapshotToArray = (snapshot) => {
  const value = snapshot.val()
  if (!value) return []

  return Object.entries(value).map(([key, content]) => ({ key, ...content }))
}

const sortByCreatedAt = (items = []) => {
  return items.slice().sort((left, right) => {
    const leftValue = left.createdAt || left.createAt || ''
    const rightValue = right.createdAt || right.createAt || ''

    if (leftValue < rightValue) return -1
    if (leftValue > rightValue) return 1
    return 0
  })
}

const sortByKeyDesc = (items = []) => {
  return items.slice().sort((left, right) => {
    if (left.key < right.key) return 1
    if (left.key > right.key) return -1
    return 0
  })
}

const buildCursorPageResult = (items = [], perPage = 5) => {
  const hasNext = items.length > perPage
  const pageCases = items.slice(0, perPage)
  const nextCursor = pageCases.length > 0 ? pageCases[pageCases.length - 1].key : null

  return {
    cases: pageCases,
    hasNext,
    nextCursor,
  }
}

const buildCompanyCasesQuery = ({ companyId, limit, cursorKey = null }) => {
  // equalTo() は endAt()/startAt() と併用できないため、会社IDの範囲を明示してページングする。
  let query = caseRef.orderByChild('user/companyId').startAt(companyId)

  if (cursorKey) {
    return query.endAt(companyId, cursorKey).limitToLast(limit)
  }

  return query.endAt(companyId).limitToLast(limit)
}

export const actions = {
  /**
   * バッチで選択された新規タグリクエストを削除
   * @param {Function} dispatch
   * @param {Array<{requestId: string, index: number}>} toDelete
   */
  deleteNewTagRequests: (dispatch, toDelete) => {
    console.log("deleteNewTagRequests", toDelete)
    // Firebase Realtime Database の multi-path update 用オブジェクト
    const updates = {}
    toDelete.forEach(({ requestId, index }) => {
      // tag 配列の該当インデックスを null に設定して削除
      updates[`${requestId}/tag/${index}`] = null
    })

    newTagsRef
      .update(updates)
      .then(() => {
        // Redux 的な state 更新アクション
        dispatch({
          type: 'DELETE_NEW_TAG_REQUESTS',
          data: toDelete,
        })
      })
      .catch(err => {
        console.error('deleteNewTagRequests error:', err)
      })
  },
  getMasterData: (dispatch) => {
    masterRef.child('feedbackCaseTag').once('value', (snapshot) => {
      const feedbackCaseTag = snapshot.val()
      if (feedbackCaseTag) { dispatch({ type: 'SET_FEEDBACK_CASE_TAG', data: feedbackCaseTag }) }
    })
  },
  getIndustries: (dispatch) => {
    masterRef.child('industries').once('value', (snapshot) => {
      const industies = snapshot.val()
      if (industies) { dispatch({ type: 'SET_INDUSTRIES', data: industies }) }
    })
  },
  getMemberNums: (dispatch) => {
    masterRef.child('memberNums').once('value', (snapshot) => {
      const memberNums = snapshot.val()
      if (memberNums) { dispatch({ type: 'SET_MEMBERNUMS', data: memberNums }) }
    })
  },
  getPrefs: (dispatch) => {
    masterRef.child('prefs').once('value', (snapshot) => {
      const prefs = snapshot.val()
      if (prefs) { dispatch({ type: 'SET_PREFS', data: prefs }) }
    })
  },
  getOtherTags: (dispatch) => {
    masterRef
      .child('otherTags')
      .once('value', (snapshot) => {
        const otherTags = snapshot.val()
        if (otherTags) dispatch({ type: 'CHANGE_OTHER_TAGS', data: otherTags })
      })
  },
  getNewTags: dispatch => {
    newTagsRef.once('value').then(snap => {
      const raw = snap.val() || {}
      const normalized = Object.entries(raw).reduce((acc, [id, group]) => {
        // DB がオブジェクトで返す場合もあるので配列化
        const tags = Array.isArray(group.tag)
          ? group.tag.filter(Boolean)
          : Object.values(group.tag || {}).filter(Boolean)
        if (tags.length) {
          acc[id] = { ...group, tag: tags }
        }
        return acc
      }, {})
      dispatch({ type: 'CHANGE_NEW_TAGS', data: normalized })
    })
  },
  getCase: (dispatch, key) => {
    console.log("get case")
    caseRef.child(key)
      .once('value', (snapshot) => {
        const value = snapshot.val()
        if (!isValidCaseRecord(value)) {
          warnInvalidCaseRecordOnce(key, value)
          dispatch({ type: 'SET_CASE', data: {} })
          return
        }
        dispatch({ type: 'SET_CASE', data: value })
      })
  },
  getCases: async (dispatch, companyId = null) => {
    const ref = companyId 
      ? caseRef.orderByChild("user/companyId").equalTo(companyId)
      : caseRef.orderByKey();

    try {
      // 事例本体は一覧を開くたびに常時購読せず、まずは単発取得に寄せる。
      const snapshot = await ref.once('value')
      console.log("get case", companyId)
      const cases = filterValidCaseRecords(snapshotToArray(snapshot))
      dispatch({ type: 'SET_CASES', data: sortByKeyDesc(cases) })
    } catch (error) {
      console.error('getCases error', error)
      dispatch({ type: 'SET_CASES', data: [] })
    }
  },
  getCasesPage: async ({ perPage = 5, cursorKey = null, companyId = null, feedbackOnly = false }) => {
    if (!companyId && !feedbackOnly) {
      return collectValidCasePage({
        perPage,
        cursorKey,
        fetchChunk: async ({ cursorKey: nextCursor, limit }) => {
          let query = caseRef.orderByKey()

          if (!nextCursor) {
            query = query.limitToLast(limit)
          } else {
            query = query.endAt(nextCursor).limitToLast(limit)
          }

          const snapshot = await query.once('value')
          return sortByKeyDesc(snapshotToArray(snapshot))
        },
      })
    }

    if (companyId && !feedbackOnly) {
      return collectValidCasePage({
        perPage,
        cursorKey,
        fetchChunk: async ({ cursorKey: nextCursor, limit }) => {
          const query = buildCompanyCasesQuery({
            companyId,
            limit,
            cursorKey: nextCursor,
          })
          const snapshot = await query.once('value')
          return sortByKeyDesc(snapshotToArray(snapshot))
        },
      })
    }

    if (companyId && feedbackOnly) {
      const scanLimit = Math.max(perPage * 4, 20)
      let nextQueryCursor = cursorKey
      let scannedToEnd = false
      let matchedCases = []

      while (matchedCases.length <= perPage && !scannedToEnd) {
        const query = buildCompanyCasesQuery({
          companyId,
          limit: nextQueryCursor ? scanLimit + 1 : scanLimit,
          cursorKey: nextQueryCursor,
        })

        const currentCursor = nextQueryCursor
        const snapshot = await query.once('value')
        let companyCases = sortByKeyDesc(filterValidCaseRecords(snapshotToArray(snapshot)))

        if (currentCursor) {
          companyCases = companyCases.filter((content) => content.key !== currentCursor)
        }

        if (companyCases.length <= 0) {
          scannedToEnd = true
          break
        }

        const exists = new Set(matchedCases.map((content) => content.key))
        companyCases
          .filter((content) => !!content.isFeedback)
          .forEach((content) => {
            if (!exists.has(content.key)) {
              matchedCases.push(content)
              exists.add(content.key)
            }
          })

        if (companyCases.length < scanLimit) {
          scannedToEnd = true
        } else {
          nextQueryCursor = companyCases[companyCases.length - 1].key
        }
      }

      return buildCursorPageResult(matchedCases, perPage)
    }

    return {
      cases: [],
      hasNext: false,
      nextCursor: null,
    }
  },
  changeGood: (dispatch, props) => {
    console.log("changeGood")
    const { caseGoods, goodCaseKeys, caseKey, user } = props

    const now = dayjs().tz().format('YYYY-MM-DD HH:mm:ss')
    const copyArr = goodCaseKeys.slice()
    const isAdd = copyArr.includes(caseKey) ? false : true

    if (isAdd) {
      goodsRef.push({
        user: user,
        caseKey: caseKey,
        createdAt: now,
        type: 'case',
      })
      dispatch({ type: 'CHANGE_GOOD_CASE_KEYS', data: copyArr.concat(caseKey) })
    } else {
      const goods = caseGoods.filter(good => good.caseKey === caseKey)
      goods.map(g => (
        // 削除する
        goodsRef.child(g.key).remove()
          .then(() => {
            const index = copyArr.indexOf(caseKey)
            copyArr.splice(index, 1)
            dispatch({ type: 'CHANGE_GOOD_CASE_KEYS', data: copyArr })
          })
      ))
    }
  },
  getGoods: (dispatch, uid) => {
    const query = goodsRef.orderByKey()
    const handleValue = (snapshot) => {
      console.log("get good")
      const newAllGoods = sortByKeyDesc(snapshotToArray(snapshot))
      const newGoods = newAllGoods.filter(g => g.user.uid === uid)
      dispatch({ type: 'SET_ALL_GOODS', data: newAllGoods })
      dispatch({ type: 'SET_GOODS', data: newGoods })
    }

    query.on('value', handleValue)

    return () => query.off('value', handleValue)
  },
  getComments: (dispatch) => {
    const query = caseCommentsRef.orderByChild('createdAt')
    const handleValue = (snapshot) => {
      console.log("get comment")
      dispatch({ type: 'SET_COMMENTS', data: sortByCreatedAt(snapshotToArray(snapshot)) })
    }

    query.on('value', handleValue)

    return () => query.off('value', handleValue)
  },
  watchVisibleComments: (dispatch, caseKeys = []) => {
    const uniqueCaseKeys = Array.from(new Set(caseKeys.filter(Boolean)))

    if (uniqueCaseKeys.length <= 0) {
      dispatch({ type: 'SET_COMMENTS', data: [] })
      return () => {}
    }

    const perCaseComments = {}
    const syncComments = () => {
      // 表示中の事例に紐づくコメントだけを束ねて state に流す。
      const mergedComments = uniqueCaseKeys.flatMap(caseKey => perCaseComments[caseKey] || [])
      dispatch({ type: 'SET_COMMENTS', data: sortByCreatedAt(mergedComments) })
    }

    const cleanups = uniqueCaseKeys.map((caseKey) => {
      const query = caseCommentsRef.orderByChild('caseKey').equalTo(caseKey)
      const handleValue = (snapshot) => {
        perCaseComments[caseKey] = snapshotToArray(snapshot)
        syncComments()
      }

      query.on('value', handleValue)

      return () => query.off('value', handleValue)
    })

    return () => {
      cleanups.forEach((cleanup) => cleanup())
      dispatch({ type: 'SET_COMMENTS', data: [] })
    }
  },
  watchVisibleGoods: (dispatch, uid, caseKeys = []) => {
    const uniqueCaseKeys = Array.from(new Set(caseKeys.filter(Boolean)))

    if (uniqueCaseKeys.length <= 0) {
      dispatch({ type: 'SET_ALL_GOODS', data: [] })
      dispatch({ type: 'SET_GOODS', data: [] })
      return () => {}
    }

    const perCaseGoods = {}
    const syncGoods = () => {
      // いいね件数表示用の全体データと、自分が押したか判定用の個人データを同時に作る。
      const mergedGoods = uniqueCaseKeys.flatMap(caseKey => perCaseGoods[caseKey] || [])
      dispatch({ type: 'SET_ALL_GOODS', data: mergedGoods })
      dispatch({ type: 'SET_GOODS', data: mergedGoods.filter(good => good.user.uid === uid) })
    }

    const cleanups = uniqueCaseKeys.map((caseKey) => {
      const query = goodsRef.orderByChild('caseKey').equalTo(caseKey)
      const handleValue = (snapshot) => {
        perCaseGoods[caseKey] = snapshotToArray(snapshot)
        syncGoods()
      }

      query.on('value', handleValue)

      return () => query.off('value', handleValue)
    })

    return () => {
      cleanups.forEach((cleanup) => cleanup())
      dispatch({ type: 'SET_ALL_GOODS', data: [] })
      dispatch({ type: 'SET_GOODS', data: [] })
    }
  },
  moutedGetData: (dispatch, _uid, companyId = null) => {
    actions.getCases(dispatch, companyId)
    actions.getMasterData(dispatch)
    actions.getIndustries(dispatch)
    actions.getMemberNums(dispatch)
    actions.getPrefs(dispatch)
    actions.getOtherTags(dispatch)
  },
  updateComment: (dispatch, comment, editComments) => {
    console.log("UpdateComment")
    const now = dayjs().tz().format('YYYY-MM-DD HH:mm:ss')
    const newCmnt = editComments[comment.key]
    caseCommentsRef.child(comment.key)
      .update({
        ...newCmnt,
        updateAt: now
      })
    dispatch({ type: 'IS_SHOW_CMNT_FIELD', field: comment.key, data: false })
  },

  postComment: (dispatch, props) => {
    const now = dayjs().tz().format('YYYY-MM-DD HH:mm:ss')
    const { text, caseKey, user, video, isUploadVideo } = props
    const isVideo = isUploadVideo && hasVideoUrl(video?.video)
    const videoData = !isVideo ? {} : { video: video.video }

    caseCommentsRef.push({
      text: text,
      user: user,
      caseKey: caseKey,
      createdAt: now,
      ...videoData,
    })

    // NOTE: パジャポス権限が動画をアップロードした場合、フィードバックタグを付与
    if (isVideo && user.pajaposs) {
      caseRef.child(caseKey)
        .update({
          isFeedback: true,
          updateAt: now
        })
    }

    console.log('COMMENT_RESET');
    dispatch({ type: 'COMMENT_RESET', field: caseKey })
  },

  getCompany: async (dispatch, companyId) => {
    try {
      const snapshot = await companiesRef.child(companyId).once('value')
      console.log("get company")
      const company = snapshot.val()
      dispatch({ type: 'SET_COMPANY', data: !!company ? company : {} })
    } catch (error) {
      console.error('getCompany error', error)
      dispatch({ type: 'SET_COMPANY', data: {} })
    }
  },
  sendNotice: async (input, user, dispatch) => {
    const doNotify = await adminActions.getDoNotify(dispatch)
    if (!doNotify) return
    const msg = `
事例が共有されました。
==========================================
${user.companyInfo.name}
${input.text}
${SITEINFO.appUrl}
`
    let notices = {}
    const setNotices = async (data) => { return notices = { ...notices, ...data } }
    await setNotices((await noticeRef.child('all').once('value')).val())
    await setNotices((await noticeRef.child('caseAll').once('value')).val())
    await Promise.all(input.industryTags.map(async tag => {
      const path = 'case' + tag.value.charAt(0).toUpperCase() + tag.value.slice(1)
      setNotices((await noticeRef.child(path).once('value')).val())
    }))

    console.log("notices", notices)

    // 重複を削除
    const arr = Object.entries(notices).map(([key, value]) => ({ [key]: value }))
    const result = arr.filter((element, index, self) => self.findIndex(e => e.userId === element.userId) === index)
    const obj = {}
    result.forEach((data, i) => { Object.entries(data).map(([key, value]) => obj[key] = value) })

    const func = functions.httpsCallable("noticeV2")
    func({ notices: obj, msg: msg })
      .then(res => {
        console.log(res);
      }).catch(e => {
        console.log(e);
      })
  },
  filterCases: (dispatch, searchTag, cases, tags) => {
    const {
      industryTagList,
      memberNumTagList,
      prefTagList,
      feedbackCaseTag,
      otherTagList,
    } = tags

    const selectTag = () => {
      if (!searchTag) return null;
    
      const isFeedbackTag = (feedbackCaseTag.id === searchTag.id) &&
                            (feedbackCaseTag.label === searchTag.label) &&
                            (feedbackCaseTag.value === searchTag.value);
      
      if (isFeedbackTag) {
        return { type: 'feedback', id: searchTag.id };
      }
    
      const member = memberNumTagList.find((tag) => 
        (tag.id === searchTag.id) &&
        (tag.label === searchTag.label) &&
        (tag.value === searchTag.value)
      );
      if (member) {
        return { type: 'member', id: member.id };
      }
    
      const industry = industryTagList.find((tag) => 
        (tag.id === searchTag.id) &&
        (tag.label === searchTag.label) &&
        (tag.value === searchTag.value)
      );
      if (industry) {
        return { type: 'industry', id: industry.id };
      }
    
      const pref = prefTagList.find((tag) => 
        (tag.id === searchTag.id) &&
        (tag.label === searchTag.label) &&
        (tag.value === searchTag.value)
      );
      if (pref) {
        return { type: 'pref', id: pref.id };
      }
    
      const other = otherTagList.find((tag) => 
        (tag.id === searchTag.id) &&
        (tag.label === searchTag.label) &&
        (tag.value === searchTag.value)
      );
      if (other) {
        return { type: 'other', id: other.id };
      }
    
      return false; // 登録のない単語
    };

    const selectedTag = selectTag()
    if (selectedTag === false) return dispatch({ type: 'SET_FILERED_CASES', data: [] })
    if (!selectedTag) return dispatch({ type: 'SET_FILERED_CASES', data: cases })


    let data = []
    const setFeedbackCases = () => cases.filter(c => c.isFeedback); // 名前付き関数
    const setCases = (type) => cases.filter(c => c[type]?.some(tag => tag.id === selectedTag.id)); // 名前付き関数
    const setMemberCases = (type) => cases.filter(c => c[type].id === selectedTag.id); // 名前付き関数

    // 下記のようにフィルタリングの処理も名前付き関数を活用
    switch (selectedTag.type) {
      case 'feedback':
        data = setFeedbackCases();
        break;
      case 'other':
        data = setCases('otherTags');
        break;
      case 'industry':
        data = setCases('industryTags');
        break;
      case 'member':
        data = setMemberCases('memberNumTags');
        break;
      case 'pref':
        data = setCases('prefTags');
        break;
      default:
        break;
    }
    dispatch({ type: 'SET_FILERED_CASES', data })
  },
}
